import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import vars from 'li-components/lib/styles'

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;

  > div {
    width: 100%;
    max-width: 390px;
    padding: 3rem;
    background: ${vars.marketingPanelBackgroundColor};
    border: ${vars.cardBorderWidth} solid ${vars.cardBorderColor};
    border-radius: ${vars.inputBorderRadius};
  }
`

const Header = styled.header`
  margin-bottom: 3rem;

  > h4 {
    padding: 0 0 10px;
    margin: 0 0 10px;
    border-bottom: 1px solid ${vars.grayLighter};
    font-size: 20px;
    font-weight: 700;
  }
`

const MarketingPanel = ({ title, children, className }) => (
  <Container className={`MarketingPanel ${className}`}>
    <div>
      {title && (
        <Header>
          <h4>{title}</h4>
        </Header>
      )}
      {children}
    </div>
  </Container>
)

MarketingPanel.defaultProps = {
  className: '',
}

MarketingPanel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
}

export default MarketingPanel



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/MarketingPanel.js